var en_GB = {};
module['exports'] = en_GB;
en_GB.title = "Great Britain (English)";
en_GB.address = require("./address");
en_GB.internet = require("./internet");
en_GB.phone_number = require("./phone_number");
en_GB.cell_phone = require("./cell_phone");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/index.js
 ** module id = 398
 ** module chunks = 0
 **/